import { useTranslation } from "react-i18next";
import { FlexierTypography } from "./FlexierTypography";
import useStyles from "./styles";

export function CustomOption(props: { name: string; isActive: boolean; localizedOption?: string }) {
	const { ellipsisRule } = useStyles();
	const { t } = useTranslation();

	return (
		<FlexierTypography className={ellipsisRule} color={props.isActive ? "primary" : undefined}>
			{props.name === props.localizedOption ? t(props.name) : props.name}
		</FlexierTypography>
	);
}
